import React from "react";

export const SLocalisationIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.4796 7.51843C21.6936 4.96843 19.0316 2.30543 16.4806 3.51943L4.82156 9.07143C2.43156 10.2094 2.57956 13.6604 5.05856 14.5894L7.79756 15.6164C7.93116 15.6666 8.05249 15.7447 8.15339 15.8456C8.25429 15.9465 8.33243 16.0678 8.38256 16.2014L9.40956 18.9414C10.3396 21.4194 13.7896 21.5674 14.9276 19.1774L20.4796 7.51843Z"
          fill="white"
        />
      </svg>
    </div>
  );
};
